import { getApolloDomainConfigs } from '@/config/domainRegistry'
import { ApolloDomainConfig } from '@/config/domainRegistry/apollo/apolloDomainConfig'
import VueApollo, { ApolloProvider } from 'vue-apollo'
import { AuthOptions, createAuthLink } from 'aws-appsync-auth-link'
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link'
import { Auth } from 'aws-amplify'
import { ApolloLink } from 'apollo-link'
import { createHttpLink } from 'apollo-link-http'

import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloClient } from 'apollo-client'

const VUE_APP_AWS_APPSYNC_REGION = 'eu-west-1'
const VUE_APP_AWS_APPSYNC_AUTH_TYPE = 'AMAZON_COGNITO_USER_POOLS'

let apolloConfigs: ApolloDomainConfig[] = []
export var clients: { [name: string]: ApolloClient<any> } = {}

export const addApolloConfigs = async () => {
  apolloConfigs = getApolloDomainConfigs()
}

const auth: AuthOptions = {
  type: VUE_APP_AWS_APPSYNC_AUTH_TYPE,
  jwtToken: async () => {
    const currentSession = await Auth.currentSession()
    return currentSession.getAccessToken().getJwtToken()
  }
}

function createClient(domainConfig: ApolloDomainConfig): ApolloClient<any> {
  if (domainConfig.config.region === undefined) {
    domainConfig.config.region = VUE_APP_AWS_APPSYNC_REGION
  }
  if (domainConfig.config.disableOffline === undefined) {
    domainConfig.config.disableOffline = true
  }
  domainConfig.config.auth = auth
  let url = domainConfig.config.url
  let region = domainConfig.config.region

  const httpLink = createHttpLink({ uri: url })

  const link = ApolloLink.from([
    createAuthLink({ url, region, auth }),
    createSubscriptionHandshakeLink(url, httpLink)
  ])

  return new ApolloClient({
    link,
    cache: new InMemoryCache()
  })

  // return new AWSAppSyncClient(domainConfig.config, domainConfig.options)
}

function createClients(): { [key: string]: ApolloClient<any> } {
  for (let config of apolloConfigs) {
    clients[config.name] = createClient(config)
  }
  return clients
}

export function createProvider(options = {}): ApolloProvider {
  clients = createClients()
  return new VueApollo({
    clients: clients,
    defaultClient: clients['SHOWCASE']
  })
}
